
import { GridLoader } from "react-spinners";

function SuspenseContent(){
    return(
        <div className="w-full h-screen  flex justify-center items-center ">
           <GridLoader color="#7B1E19" />
        </div>
    )
}

export default SuspenseContent;